<template>
  <q-dialog ref="dialog" :persistent="persistent" @show="$emit('show')" @hide="$emit('hide')" :full-width="fullWidth" :full-height="fullHeight">
    <q-card class="full-width column no-wrap" :style="{maxWidth}">
      <q-card-section class="row bg-primary text-white">
        <div class="text-h6">{{title}}</div>
        <q-space/>
        <q-btn flat dense round @click="hide" icon="close" aria-label="Close"/>
      </q-card-section>

      <q-card-section class="q-pt-none column col">
        <slot></slot>
      </q-card-section>

      <slot name="actions"></slot>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: "ModalDialog",
  props: {
    title: {
      type: String,
    },
    persistent: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: undefined
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
  },
  emits: ['show', 'hide'],
  methods: {
    show() {
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    }
  }
}

</script>
